<template>
  <div v-if="dialogVisible" class="reset-password-overlay" @click.self="closeDialog">
    <auth-brand-layout>
      <div class="auth-card reset-card">
        <button type="button" class="reset-close" @click="closeDialog">
          <i class="el-icon-close"></i>
        </button>

        <h3 class="auth-card__title">{{ $t('header.resetPassword') }}</h3>

        <el-form v-if="isreset" :model="resetForm" :rules="resetValidate" ref="resetForm" label-width="0" class="reset-form">
          <div v-if="isShow" class="field-block">
            <label>{{ $t('login.currentPassword') }}</label>
            <el-form-item prop="currentPassword">
              <el-input
                :class="changeCurrentFlag == 1 ? '' : 'errorPass'"
                :type="resetForm.currentPwdType"
                v-model="resetForm.currentPassword"
                :placeholder="$t('login.currentPasswordPlaceholder')"
                autocomplete="off"
              ></el-input>
              <img :src="resetForm.currentSeen ? openeye : nopeneye" class="eye" alt="" @click="changeType('currentSeen')">
            </el-form-item>
          </div>

          <div class="field-block">
            <label>{{ isShow ? $t('login.newPassword') : $t('login.enterPassword') }}</label>
            <el-form-item prop="newPassword">
              <el-input
                :class="changeFlag == 1 ? '' : 'errorPass'"
                :type="resetForm.newPwdType"
                v-model="resetForm.newPassword"
                :placeholder="$t('login.newPasswordPlaceholder')"
                autocomplete="off"
              ></el-input>
              <img :src="resetForm.NewSeen ? openeye : nopeneye" class="eye" alt="" @click="changeType('NewSeen')">
            </el-form-item>
          </div>

          <div class="field-block">
            <label>{{ isShow ? $t('login.confirmNewPassword') : $t('login.confirmPassword') }}</label>
            <el-form-item prop="ConfirmNewPassword">
              <el-input
                :class="changeAgainFlag == 1 ? '' : 'errorPass'"
                :type="resetForm.confirmNewPwdType"
                v-model="resetForm.ConfirmNewPassword"
                :placeholder="$t('login.confirmPasswordPlaceholder')"
                autocomplete="off"
              ></el-input>
              <img :src="resetForm.confirmNewSeen ? openeye : nopeneye" class="eye" alt="" @click="changeType('confirmNewSeen')">
            </el-form-item>
          </div>

          <el-button class="auth-submit" type="primary" @click="toReset">{{ $t('auth.saveNewPassword') }}</el-button>
        </el-form>

        <div v-else class="save-tip">
          <p>{{ $t('login.savedPsw') }}</p>
        </div>
      </div>
    </auth-brand-layout>
  </div>
</template>

<script>
import AuthBrandLayout from '@/components/AuthBrandLayout'

export default {
  name: 'ResetPasswordDialog',
  components: {
    AuthBrandLayout
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    resetType: {
      type: Number,
      default: 1
    }
  },
  data () {
    const currentpwdCheck = async (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.currentpswEmpty')))
      } else if (!reg.test(value)) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeCurrentFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswSameAs')))
      } else {
        this.changeCurrentFlag = 1
        callback()
      }
    }
    const pwdCheck = async (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswEmpty')))
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.passwordLessThan')))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswSameAs')))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        this.changeAgainFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswEmpty')))
      } else if (this.resetForm.newPassword != this.resetForm.ConfirmNewPassword) {
        this.changeAgainFlag = 2
        return callback(new Error(this.$t('errorprompt.newPswDontSame')))
      } else {
        this.changeAgainFlag = 1
        callback()
      }
    }
    return {
      resetForm: {
        currentPassword: '',
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        currentSeen: false,
        confirmNewSeen: false,
        currentPwdType: 'password',
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      resetValidate: {
        currentPassword: [
          { required: true, validator: currentpwdCheck, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ],
        ConfirmNewPassword: [
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      changeCurrentFlag: 1,
      changeFlag: 1,
      changeAgainFlag: 1,
      openeye: require('@/assets/eye.svg'),
      nopeneye: require('@/assets/eye-off.svg'),
      isreset: true,
      issave: false,
      isShow: true
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.isShow = this.resetType === 1
        this.isreset = true
        this.issave = false
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialogVisible = false
      this.resetState()
    },
    resetState () {
      this.resetForm = {
        currentPassword: '',
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        currentSeen: false,
        confirmNewSeen: false,
        currentPwdType: 'password',
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      }
      this.isreset = true
      this.issave = false
      if (this.$refs.resetForm) {
        this.$refs.resetForm.clearValidate()
      }
    },
    changeType (seen) {
      if (seen == 'currentSeen') {
        this.resetForm.currentPwdType = this.resetForm.currentPwdType === 'password' ? 'text' : 'password'
        this.resetForm.currentSeen = !this.resetForm.currentSeen
      } else if (seen == 'NewSeen') {
        this.resetForm.newPwdType = this.resetForm.newPwdType === 'password' ? 'text' : 'password'
        this.resetForm.NewSeen = !this.resetForm.NewSeen
      } else if (seen == 'confirmNewSeen') {
        this.resetForm.confirmNewPwdType = this.resetForm.confirmNewPwdType === 'password' ? 'text' : 'password'
        this.resetForm.confirmNewSeen = !this.resetForm.confirmNewSeen
      }
    },
    toReset () {
      if (this.resetType === 1) {
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['currentPassword'][0].message || msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }
          this.$http.post('/api/member/pass', {
            old_pwd: this.resetForm.currentPassword,
            new_pwd: this.resetForm.newPassword,
            _method: 'PUT'
          }).then((res) => {
            if (res.data.code == 200) {
              this.issave = !this.issave
              this.isreset = !this.isreset
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error)
          })
        })
      } else {
        this.$refs.resetForm.validate((valid, msg) => {
          if (!valid) {
            this.$message(msg['newPassword'][0].message || msg['ConfirmNewPassword'][0].message)
            return false
          }
          this.$http.post('/api/setPass', {
            password: this.resetForm.newPassword
          }).then((res) => {
            if (res.data.code == 200) {
              this.issave = !this.issave
              this.isreset = !this.isreset
              this.$message({
                message: res.data.msg,
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'warning'
              })
            }
          }).catch((error) => {
            console.log(error)
          })
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.reset-password-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.35);
  overflow: auto;
}

.reset-card {
  position: relative;
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(16, 24, 40, 0.08);
  padding: 32px 36px 28px;
  box-sizing: border-box;
}

.reset-close {
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: transparent;
  font-size: 18px;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
}

.auth-card__title {
  margin: 0 0 28px;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
  color: #111827;
}

.field-block {
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #374151;
    font-weight: 500;
  }
}

.reset-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__content {
    position: relative;
    margin-left: 0 !important;
  }

  /deep/ .el-input__inner {
    height: 44px;
    line-height: 44px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    color: #111827;
    padding: 0 44px 0 14px;
    background: #fff;
  }

  /deep/ .errorPass .el-input__inner {
    border-color: #fc424c;
  }

  .eye {
    width: 18px;
    height: 18px;
    position: absolute;
    right: 14px;
    top: 13px;
    cursor: pointer;
  }
}

.auth-submit {
  width: 100%;
  height: 44px;
  margin-top: 8px;
  background: #b50604;
  border-color: #b50604;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}

.save-tip {
  text-align: center;
  padding: 24px 0;
  font-size: 16px;
  color: #353643;
}
</style>



// WEBPACK FOOTER //
// src/components/children/ResetPasswordDialog.vue